export const LEGAL_ENTITY_TYPES = {
  ltd: "ООО",
  pe: "ИП",
  self_employed: "Самозанятый"
};
